import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CartContext = createContext(null);
const KEY = "lonewolf_cart_v2";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const [checkingOut, setCheckingOut] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch {
      /* ignore */
    }
  }, [items]);

  // item: { variantId, productTitle, variantTitle, price, currency, image, handle }
  const addItem = (item, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.variantId === item.variantId);
      if (idx > -1) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: next[idx].qty + qty };
        return next;
      }
      return [...prev, { ...item, qty }];
    });
  };

  const setQty = (variantId, qty) =>
    setItems((prev) =>
      prev
        .map((i) => (i.variantId === variantId ? { ...i, qty: Math.max(0, qty) } : i))
        .filter((i) => i.qty > 0)
    );

  const removeItem = (variantId) => setItems((prev) => prev.filter((i) => i.variantId !== variantId));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.qty * i.price, 0);
  const currency = items[0]?.currency || "CAD";

  const checkout = async () => {
    if (!items.length) return { error: "empty" };
    setCheckingOut(true);
    try {
      const lines = items.map((i) => ({ variantId: i.variantId, quantity: i.qty }));
      const { data } = await axios.post(`${API}/shop/cart`, { lines });
      window.location.href = data.checkoutUrl;
      return { ok: true };
    } catch (e) {
      setCheckingOut(false);
      return { error: "failed" };
    }
  };

  return (
    <CartContext.Provider
      value={{ items, addItem, setQty, removeItem, clear, count, subtotal, currency, open, setOpen, checkout, checkingOut }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
};

export const money = (amount, currency = "CAD") => {
  try {
    return new Intl.NumberFormat("en-CA", { style: "currency", currency, maximumFractionDigits: 0 }).format(amount);
  } catch {
    return `$${Math.round(amount)}`;
  }
};
